import { cn } from "lib/utils";
import { MoreOptions, ThreeDots } from "asset/icons";
import ActionDropdown from "component/actionDropdown";

const MoreOptionsDropdown = ({ options, horizontal = false, dropClassName = "w-[220px]" }) => {
    return (
        <ActionDropdown
            element={
                !horizontal ? (
                    <MoreOptions
                        className={cn("text-gray-500 !w-8 !h-8 cursor-pointer hover:text-gray-700")}
                    />
                ) : (
                    <ThreeDots />
                )
            }
            options={options}
            dropClassName={cn(dropClassName)}
        />
    );
};

export default MoreOptionsDropdown;
